import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export const log = (breakpoint = false) => <T>(source: Observable<T>) => source.pipe(
  tap(s => {
    console.log(s);
    if (breakpoint) {
      // eslint-disable-next-line no-debugger
      debugger;
    }
  })
);
